"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Repeat;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Repeat(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "repeat"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M58.887,84.582a2.5,2.5,0,1,0-1.623-4.729,31.563,31.563,0,1,1,18.619-42.6L66.4,32.722a2.5,2.5,0,1,0-2.154,4.511l15.077,7.2a2.57,2.57,0,0,0,1.913.1,2.5,2.5,0,0,0,1.422-1.283L89.3,29.267a2.5,2.5,0,1,0-4.515-2.147l-4.1,8.636a36.558,36.558,0,1,0-21.8,48.826Z"
  }))));
}